import { useCallback, useState } from 'react';

import { EditorBuilderActions } from '../../types';
import settingsDialogs from '../config';
import { DialogComponent, Dialogs as DialogsType, SetDialogProps } from '../types';

const useSetDialogs = (props: SetDialogProps) => {
  const { onAction } = props;
  const [activeDialog, setActiveDialog] = useState<{
    component: DialogComponent;
  } | null>(null);

  const setDialog = useCallback(
    (dialogComponentRef: DialogsType | null) => {
      if (dialogComponentRef === null) {
        setActiveDialog(null);
      } else if (dialogComponentRef === DialogsType.Import) {
        onAction(EditorBuilderActions.SetImportDialog, { hide: false });
      } else {
        setActiveDialog({
          component: settingsDialogs[dialogComponentRef],
        });
      }
    },
    [onAction],
  );

  return {
    setDialog,
    activeDialog,
  };
};

export default useSetDialogs;
